<div class="d-flex">
  <mat-form-field appearance="fill">
    <mat-label>Revisions</mat-label>
    <mat-select (selectionChange)="archiveSelected($event)">
      <mat-option *ngFor="let archive of archives" [value]="archive.archiveSignId">
        {{ archive.fileName }} - {{ archive.signDate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <button
    mat-icon-button
    type="button"
    class="download"
    matTooltip="Download"
    matTooltipPosition="above"
    (click)="downloadFile()"
    [disabled]="selectedArchiveId === null || (isFileActionIsProgress$ | async)"
  >
    <mat-icon>get_app</mat-icon>
  </button>
  <button
    mat-icon-button
    type="button"
    matTooltip="Preview"
    matTooltipPosition="above"
    class="preview d-none d-xl-flex"
    (click)="previewFile()"
    [disabled]="selectedArchiveId === null || (isFileActionIsProgress$ | async)"
  >
    <mat-icon>zoom_in</mat-icon>
  </button>
</div>
